// extracted by mini-css-extract-plugin
export default {"up":"BackToTopButton_up__UsVuN"};